<template>
  <div class="Culture">
    <section class="Culture-header">
      <h1 class="header-title">{{ $t('jobs_page.header_three') }}</h1>
      <p class="header-text">
        {{ $t('jobs_page.body_three') }}
      </p>
    </section>
    <section class="Culture-icons">
      <Icon
        svgPath="likemind-ic"
        :title="$t('jobs_page.values1_title')"
        :text="$t('jobs_page.values1_txt')"
      />
      <Icon
        svgPath="green-ic"
        :title="$t('jobs_page.values2_title')"
        :text="$t('jobs_page.values2_txt')"
      />
      <Icon
        svgPath="growth-ic"
        :title="$t('jobs_page.values3_title')"
        :text="$t('jobs_page.values3_txt')"
      />
      <Icon
        svgPath="wfh-ic"
        :title="$t('jobs_page.values4_title')"
        :text="$t('jobs_page.values4_txt')"
      />
    </section>
  </div>
</template>

<script>
import Icon from './Icon.vue';

export default {
  components: { Icon },
};
</script>

<style scoped>
.Culture {
  --culture-grid-rows: auto;
  --culter-icon-grid-cols: 1fr;
  --culture-header-max-size: 80%;
  --culture-header-margin-bottom: 3em;
  --culture-padding-top: 140px;
  padding-top: var(--culture-padding-top);
  display: grid;
  grid-template-rows: var(--culture-grid-rows);
}
.Culture-header {
  justify-self: center;
  text-align: center;
  max-width: var(--culture-header-max-size);
  margin-bottom: var(--culture-header-margin-bottom);
}
.header-title {
  color: var(--page-text-color);
  font-size: 32px;
  font-family: 'Foco';
  margin-bottom: 35px;
}
.header-text {
  font-size: 16px;
  color: var(--page-text-color);
}
.Culture-icons {
  display: grid;
  max-width: 80%;
  margin: 0 auto;
  grid-template-columns: var(--culture-icon-grid-cols);
}
@media (min-width: 768px) {
  .Culture {
    --culture-grid-rows: 0.8fr 2fr;
    --culture-icon-grid-cols: repeat(auto-fill, 50%);
    --culture-header-max-size: 70ch;
    --culture-header-margin-bottom: 0;
    --culture-padding-top: 160px;
  }
  .Culture-icons {
    max-width: 100%;
    margin: 0 auto;
    min-width: 80%;
    max-width: 1200px;
  }
}
</style>
